import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";
import {CreateVehicle, UpdateVehicle} from "../../types/api/guide/vehicle.types";

const pagedQuery = (page: number, pageSize: number, name?: string) => {
    const params: Record<string, string | number> = { page, pageSize };
    if (name != null && name.trim() !== "") params.name = name.trim();
    return { params };
};

export const vehicleService = {
    getAll: () =>
        apiCall.get(apiUrls.guide.vehicle.getAll),

    getPaged: (page: number, pageSize: number, name?: string) =>
        apiCall.get(apiUrls.guide.vehicle.getPaged, pagedQuery(page, pageSize, name)),

    create: (vehicle: CreateVehicle) =>
        apiCall.post(apiUrls.guide.vehicle.create, vehicle),

    update: (id: string, vehicle: UpdateVehicle) =>
        apiCall.put(apiUrls.guide.vehicle.update(id), vehicle),

    delete: (id: string) =>
        apiCall.delete(apiUrls.guide.vehicle.delete(id)),

    getById: (id: string) =>
        apiCall.get(apiUrls.guide.vehicle.getById(id))
}